(() => {
  'use strict';
  let nextId = 0;
  function init(box) {
    if (box.dataset.shareReady) return;
    box.dataset.shareReady = 'true';
    const button = box.querySelector('[data-share-button]');
    const panel = box.querySelector('[data-share-panel]');
    const input = box.querySelector('[data-share-link]');
    const status = box.querySelector('[data-share-status]');
    panel.id = 'bvm-share-options-' + (++nextId);
    button.setAttribute('aria-controls', panel.id);
    button.setAttribute('aria-expanded', 'false');
    button.hidden = false;

    function shareData() {
      // Build a clean link: no preview keys, tracking, cart or personalization data.
      // The guest-preview host stays intact so draft reviewers can share a design.
      const url = new URL(box.dataset.sharePath || '/', location.origin);
      url.search = '';
      url.hash = '';
      if (box.dataset.shareDesign) url.searchParams.set('design', box.dataset.shareDesign);
      const title = (box.dataset.shareTitle || 'Scripture bottle') + ' | Bible Verses Meaning';
      return { title, text: 'Take a look at this Bible Verses Meaning bottle.', url: url.href };
    }
    function reset() {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      status.textContent = '';
      input.value = '';
      box.querySelector('[data-share-email]').removeAttribute('href');
    }
    function showOptions(data) {
      input.value = data.url;
      box.querySelector('[data-share-email]').href = 'mailto:?subject=' + encodeURIComponent(data.title) + '&body=' + encodeURIComponent(data.text + '\n\n' + data.url);
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      box.querySelector('[data-share-copy]').focus();
    }
    button.addEventListener('click', async () => {
      if (!panel.hidden) { reset(); return; }
      status.textContent = '';
      const data = shareData();
      if (typeof navigator.share === 'function') {
        try { await navigator.share(data); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      showOptions(data);
    });
    box.querySelector('[data-share-copy]').addEventListener('click', async () => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(input.value);
        status.textContent = 'Link copied. Paste it into a text, email, or message.';
      } catch {
        input.focus();
        input.select();
        status.textContent = 'Select and copy this link, then paste it into your message.';
      }
    });
    box.querySelector('[data-share-close]').addEventListener('click', () => { reset(); button.focus(); });
    box.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault(); event.stopPropagation(); reset(); button.focus();
      }
    });
    box.addEventListener('bvm:share:reset', reset);
    box.closest('dialog')?.addEventListener('close', reset);
  }
  document.querySelectorAll('[data-bvm-share]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bvm-share]').forEach(init));
})();
